import { cn } from "@/lib/utils";
import { Icon } from "./Icon";

export interface AvisoNavyProps {
  /** Glifo de Material Symbols. `lock` para la evidencia congelada. */
  icono: string;
  titulo: string;
  /** Qué regla se está aplicando y qué se puede hacer igual. */
  detalle: React.ReactNode;
  /**
   * La salida constructiva — "Crear versión 2", no "Entendido". Un aviso que
   * sólo informa y no ofrece nada deja al usuario trabado sin decirle cómo
   * seguir. Opcional: hay estados (una versión ya archivada) donde de verdad
   * no queda nada por hacer.
   */
  accion?: React.ReactNode;
  className?: string;
}

/**
 * Aviso de regla de negocio (DS §6.6) — navy, NO rojo.
 *
 * La distinción es del producto y no del estilo: el rojo dice "algo salió
 * mal". Que un programa ya enviado a terreno no se pueda editar no es un
 * error, es cómo funciona la evidencia — lo firmado no se toca, se versiona.
 * Pintarlo de rojo entrena a leer una regla correcta como una falla, y a la
 * larga gasta el rojo para cuando de verdad se rompió algo.
 *
 * De ahí que la acción sea constructiva y vaya en navy sólido: es la salida
 * que la regla habilita, no un "aceptar" que sólo cierra el cartel.
 */
export function AvisoNavy({ icono, titulo, detalle, accion, className }: AvisoNavyProps) {
  return (
    <div
      className={cn(
        // `border-input` y no `border-border-subtle`: este aviso vive sobre
        // superficies blancas, y con el borde de divisor interno (#F1F1F4)
        // el recuadro se pierde contra su propio fondo.
        "bg-card border-input flex items-center gap-[11px] rounded-[9px] border px-3 py-[11px]",
        className,
      )}
    >
      <Icon name={icono} size={19} className="text-foreground shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-[12.5px] font-semibold">{titulo}</div>
        <div className="text-meta text-[11.5px] leading-[1.45]">{detalle}</div>
      </div>
      {accion}
    </div>
  );
}
